import axios from "axios";
import { handleUnauthorized } from "../Helper/authSession";

/** Login / signup / verification — 401 here means bad credentials, not expired session */
const AUTH_EXCLUDED_URL_FRAGMENTS = [
  "/professional/login",
  "/user/login",
  "/user/signUp",
  "/professional/signUp",
  "socialLogin",
  "socialLoginFromGetStarted",
  "ForgotPassword",
  "forgotPassword",
  "verifyEmail",
  "sendEmailVerification",
  "verifyPhoneNumber",
  "verifyLoginWithPhone",
  "sendVerificationCode",
  "verifyForgotPassword",
  "updatePasswordForgot",
  "addComingSoonUsers",
];

const isAuthExcludedRequest = (url = "") =>
  AUTH_EXCLUDED_URL_FRAGMENTS.some((fragment) => url.includes(fragment));

export function setupAxiosAuthInterceptor() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;

      if (status === 401) {
        const requestUrl = error?.config?.url || "";

        if (!isAuthExcludedRequest(requestUrl)) {
          const serverMessage =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            null;
          handleUnauthorized(serverMessage);
        }
      }

      return Promise.reject(error);
    }
  );
}
